module.exports = __webpack_public_path__ + "img/123.578fcb25.jpg";